import Constants from "./Constants";
import AppSnackbars from "@/components/AppSnackBars.vue";
import { Keyboard, KeyboardInfo, KeyboardResize } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";
import { Vue } from "vue-facing-decorator";
import { ComponentInternalInstance, getCurrentInstance, ref } from "vue";
// import { useRouter } from "vue-router";

let app: typeof Vue;

let pushSnackbar: (data: SnackbarData) => void;
export function setAppSnackbarInstance(pn: (data: SnackbarData) => void) {
  pushSnackbar = pn;
}

interface KeyboardEventCallbacks<T> {
  element: T;
  keyboardWillShow?: (info: KeyboardInfo) => void;
  keyboardDidShow?: (info: KeyboardInfo) => void;
  keyboardWillHide?: () => void;
  keyboardDidHide?: () => void;
}

let KeyboardEventSubscribedElements: Array<KeyboardEventCallbacks<any>> = [];

let openDialogueCallback: (dia: DialogParameter) => void;
let isDialogueOpenCallback: () => boolean;
let getDialogSiteDataCallback: () => any;
let closeHighestDialogCallback: (returnValue?: boolean, returnedData?: any) => boolean;


export function initDialogs(addDia: (dia: DialogParameter) => void,
  isDialogueOpen: () => boolean,
  getDialogSiteData: () => any,
  closeHighestDialog: (returnValue?: boolean, returnedData?: any) => boolean) {
  openDialogueCallback = addDia;
  isDialogueOpenCallback = isDialogueOpen;
  getDialogSiteDataCallback = getDialogSiteData;
  closeHighestDialogCallback = closeHighestDialog;
}

export function isDialogueOpen() { return isDialogueOpenCallback(); }
export function getDialogSiteData() { return getDialogSiteDataCallback(); }
export function closeHighestDialog(returnValue?: boolean, returnedData?: any) {
  return closeHighestDialogCallback(returnValue, returnedData);
}

export function registerForKeyBoardEvent<T>(subscriber: KeyboardEventCallbacks<T>) {
  KeyboardEventSubscribedElements.push(subscriber);
}
export function unregisterForKeyBoardEvent<T>(element: T) {
  KeyboardEventSubscribedElements = KeyboardEventSubscribedElements.filter(e => e.element !== element);
}


let keyboardVisible: boolean = false;
export function initializeUIHelper(newApp: typeof Vue) {
  if (!newApp) { throw new Error("app nicht initialisiert"); }
  app = newApp;
  console.info("UIHelper" + Capacitor.getPlatform());
  if (Capacitor.getPlatform() !== "web") {
    // wenn du die Resizings weg haben magst, dann schalte es hier ein/aus !
    // keyboard plugin doku:
    // https://capacitorjs.com/docs/apis/keyboard#setresizemode
    Keyboard.setResizeMode({ mode: KeyboardResize.Native });

    Keyboard.addListener("keyboardWillShow", (info) => {
      console.log("keyboard will show");
      KeyboardEventSubscribedElements.forEach(e => { if (e.keyboardWillShow) { e.keyboardWillShow(info); } });
    });
    Keyboard.addListener("keyboardDidShow", (info) => {
      console.log("keyboard showed");
      keyboardVisible = true;
      KeyboardEventSubscribedElements.forEach(
        e => invokeWithCatch(() => e.keyboardDidShow ? e.keyboardDidShow(info) : 0));
    });

    Keyboard.addListener("keyboardWillHide", () => {
      KeyboardEventSubscribedElements.forEach(e => invokeWithCatch(e.keyboardWillHide));
    });

    Keyboard.addListener("keyboardDidHide", () => {
      keyboardVisible = false;
      KeyboardEventSubscribedElements.forEach(e => invokeWithCatch(e.keyboardDidHide));
    });
  }
}

function invokeWithCatch(action: (() => any) | undefined) {
  try {
    if (action) { action(); }
  } catch (error) {
    console.log(error);
  }
}
export function scrollIntoView(event: Event) {
  const target = event.currentTarget as HTMLElement;
  setTimeout(() => {
    try {
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView?retiredLocale=de
      if (keyboardVisible) { target.scrollIntoView(true); }
    } catch (error) {
      console.error(error);
    }
  }, 800);
}
export function closeDialog(dlg: DialogParameter, dialogResult?: boolean) {
  if (dlg == null) {
    return false;
  }
  dlg.dialogResult = dialogResult;
  if (dlg.site && dlg.site === "ModellDialog") {
    if (dlg.data && dlg.data.getReturnData) {
      dlg.returnedData = dlg.data.getReturnData();
    }
  }
  if (dlg.onClose && typeof dlg.onClose === "function") {
    const result = dlg.onClose(dlg);
    if (result === false) {
      return false;
    }
  }
  return true;
}


export function showDialog(value: DialogParameter) {
  console.log("showDialog", value);
  if (!value.titleColor) {
    value.titleColor = "dvhBackground";
  }

  if (value.showTitle === undefined) {
    value.showTitle = true;
  }
  if (value.site === 'BaseStammMaske') { // in der StammMaske ist ein onClose - daher nicht 2 mal!
    value.showTitle = false;
  }
  // am Handy immer auf persistent true stellen! damit combox auf Android klappt!
  if (Capacitor.getPlatform() !== "web" && value.persistent === undefined) {
    value.persistent = value.fullscreen;
  }
  value.closeDialog = () => {
    closeDialog(value);
  };
  openDialogueCallback(value);
}

export function showSnackbar(data: string | SnackbarData) {

  if (!pushSnackbar) { return; }
  if (typeof data === "string") {
    pushSnackbar({ text: data });
  } else {
    pushSnackbar(data);
  }
}

export interface DialogParameter {
  title: string;
  titleClass?: string;
  titleColor?: string;
  width?: number;
  height?: number;
  dialogResult?: boolean; /* ok/abbrechen */
  returnedData?: any; /* ok/abbrechen */
  closeDialog?: () => void;
  onClose?: (param: DialogParameter) => boolean;
  site?: string;
  data?: any;
  text?: string;
  okButton?: boolean;
  noClose?: boolean;
  fullscreen?: boolean;
  persistent?: boolean;
  openGuard?: boolean; /* intern (Dialogs.vue): kurz nach dem Öffnen kein Schließen per Klick außerhalb */
  showTitle?: boolean;
  transition?: string;
  reload?: boolean;
  icon?: string;
  ergebnis?: any;
  actionLayout?: "default" | "centered";
  okText?: string;
  cancelText?: string;
}
export function printVueElement(element: HTMLElement, printTitle: string, scale: number = 1) {
  const winOptions =
    "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800," +
    "height=600,top=100,left=" +
    (screen.width - 400) / 2;
  const win = window.open("", "Title", winOptions);
  if (win) {
    const css = [...(window.document.head.getElementsByTagName("style") as any)]
      .map((cc) => cc.outerHTML)
      .join("");
    const stylesheets = [...(document.head.getElementsByTagName("link") as any)]
      .filter((l) => l.rel === "stylesheet")
      .map((l) => l.outerHTML)
      .join("");

    win.document.write(
      "<!DOCTYPE html><html><head><title>" +
      printTitle +
      "</title><meta charset='utf-8'>" +
      stylesheets +
      css +
      "<style>" +
      "body { transform: scale(" + scale + "); transform-origin: top left; }" + // Scale the body content
      "</style>" +
      "</head>"
    );
    win.document.write(
      "<body>" +
      element.outerHTML +
      "<" +
      "script>setTimeout(() => " +
      "{" +
      " window.print(); window.close();\r\n" +
      "}" +
      ", 100);" +
      "</" +
      "script>" +
      "</body></html>"
    );
    win.focus();
    return true;
  } else {
    showSnackbar({
      text: "Bitte Popups erlauben!",
      duration: 3000,
      color: "red",
    });
  }
  return false;
}

export function logComponentHierarchy() {
  const instance = getCurrentInstance();
  if (!instance) {
    console.warn("logComponentHierarchy: no instance available");
    return;
  }

  const chain: string[] = [];
  let cursor: ComponentInternalInstance | null = instance;
  while (cursor) {
    const type = cursor.type as { name?: string; __name?: string; displayName?: string };
    const name = type.name || type.__name || type.displayName || "<anonymous>";
    chain.push(`${name} (uid:${cursor.uid})`);
    cursor = cursor.parent;
  }

  console.groupCollapsed("[DialogDienstplan] component hierarchy");
  chain.forEach((entry, index) => console.log(`${index}. ${entry}`));
  console.groupEnd();
}
/**
 * Liefert einen Handler, der weitere Aufrufe innerhalb von `ms` ignoriert,
 * damit ein Doppelklick wie ein einfacher Klick behandelt wird.
 * Für mehrere Buttons mit gemeinsamer Sperre denselben Handler bzw. dieselbe Instanz verwenden.
 */
export function singleClick<A extends unknown[]>(fn: (...args: A) => void, ms = 400) {
  let last = 0;
  return (...args: A) => {
    const now = Date.now();
    if (now - last < ms) {
      return;
    }
    last = now;
    fn(...args);
  };
}

/**
 * Sperre für Bereiche, deren Inhalt sich nach einem Klick verschiebt (z.B. Carousel-Wechsel):
 * `guard(fn)` führt fn aus und setzt `locked` für `ms` auf true. Den Bereich währenddessen mit
 * `:style="locked ? 'pointer-events: none' : ''"` sperren, damit ein 2. Klick nicht auf dem
 * neu hereingeschobenen Inhalt landet.
 */
export function useClickLock(ms = 500) {
  const locked = ref(false);
  function guard<A extends unknown[]>(fn: (...args: A) => void) {
    return (...args: A) => {
      if (locked.value) {
        return;
      }
      locked.value = true;
      setTimeout(() => (locked.value = false), ms);
      fn(...args);
    };
  }
  return { locked, guard };
}
